import { render, staticRenderFns } from "./RejectWalletRequestModal.vue?vue&type=template&id=6d1430c1&scoped=true"
import script from "./RejectWalletRequestModal.vue?vue&type=script&lang=js"
export * from "./RejectWalletRequestModal.vue?vue&type=script&lang=js"
import style0 from "./RejectWalletRequestModal.vue?vue&type=style&index=0&id=6d1430c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1430c1",
  null
  
)

export default component.exports